import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';

export const SummaryCardHeader = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  align-self: flex-start;
  padding-bottom: ${pxToRem(10)};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const EditButton = styled.button`
  font-size: ${pxToRem(14)};
  color: ${({ theme: { colors } }) => colors.green_3};
  font-weight: 500;
  cursor: pointer;
  padding-left: ${pxToRem(8)};
`;

export const AdditionalIcon = styled.img`
  width: ${pxToRem(25)};
  height: ${pxToRem(25)};
`;
